import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    userStatus: null,
    numberOfQuotes: null
  },
  getters: {},
  mutations: {
    setUserStatus(state, newStatus) {
      state.userStatus = newStatus;
    },
    setNumberOfQuotes(state, newNumberOfQuotes) {
      state.numberOfQuotes = newNumberOfQuotes;
    }
  },
  actions: {
    async changeStatus({ commit }, info) {
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user-admin/${info.userId}/${info.departmentId}/${info.rolId}/`,
          info.isBusy,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setUserStatus", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async assignQuotes({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/allocate/admin/multiple-allocate/${info.departmentId}/`,
          info.payload,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setNumberOfQuotes", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async clearQuotes({ commit }, info) {
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/allocate/admin/deallocate_all_by_id/${info.departmentId}/${info.userId}/`,
          null,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setNumberOfQuotes", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
